import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDefined,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  ValidateNested,
} from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { PlanId } from '../../types';

export class PlanMetadataStripeDto {
  @IsString()
  @IsNotEmpty()
  productId!: string;

  @IsString()
  @IsNotEmpty()
  priceId!: string;
}

export class PlanMetadataDto {
  @ValidateNested()
  @Type(() => PlanMetadataStripeDto)
  @IsDefined()
  stripe!: PlanMetadataStripeDto;
}

export class PlanDto extends BaseDto<PlanId> {
  @ValidateNested()
  @Type(() => PlanMetadataDto)
  @IsDefined()
  metadata!: PlanMetadataDto;

  @IsString()
  @IsNotEmpty()
  slug!: string;

  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsNotEmpty()
  @IsEnum(['monthly', 'quarterly', 'yearly'])
  billingCycle!: string;

  @IsNumber()
  @IsNotEmpty()
  price!: number;

  @IsString()
  @IsNotEmpty()
  currency!: string;

  @IsBoolean()
  @IsNotEmpty()
  isActive!: boolean;

  @IsString({ each: true })
  features!: string[];
}

export class CreatePlanDto {
  @IsString()
  @IsNotEmpty()
  slug!: string;

  @IsString()
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsNotEmpty()
  @IsEnum(['monthly', 'quarterly', 'yearly'])
  billingCycle!: string;

  @IsNumber()
  @IsNotEmpty()
  price!: number;

  @IsString()
  @IsNotEmpty()
  currency!: string;

  @IsBoolean()
  @IsNotEmpty()
  isActive!: boolean;

  @IsString({ each: true })
  features!: string[];

  @IsString()
  @IsOptional()
  stripeProductId?: string;
}
